<agr-page-toolbar
  [isEmpty]="(cycle$ | async)?.discounts.length === 0"
  [emptyTitle]="'discount.no-discounts-title' | translate"
  [emptyDescription]="'discount.no-discounts-description' | translate"
  emptyImage="assets/images/arrival.jpg"
  data-test="discount-overview"
>
  <ng-container actions>
    <ng-container *ngIf="slaughterReports$ | async as reports">
      <button
        *ngIf="reports.length > 0"
        mat-flat-button
        color="primary"
        (click)="import()"
        data-test="discount__import"
        style="margin-right: 10px"
      >
        <mat-icon>import_export</mat-icon>{{ 'import' | translate }} ({{ reports.length }})
      </button>
    </ng-container>
    <button
      *ngIf="isAdvisor"
      mat-flat-button
      color="accent"
      (click)="addDialog()"
      data-test="discount__add"
    >
      <mat-icon>add</mat-icon>{{ 'add' | translate }}
    </button>
  </ng-container>
  <ng-container *ngIf="cycle$ | async as cycle">
    <mat-nav-list *ngIf="cycle?.discounts?.length > 0">
      <a
        mat-list-item
        *ngFor="let discount of cycle.discounts"
        class="discount__list"
        [attr.data-test]="'discount-overview__item_' + discount.id"
        (click)="openDiscountEdit(discount.id)"
      >
        <mat-icon matListItemAvatar class="list-avatar">local_offer</mat-icon>

        <div matListItemTitle>
          {{ 'discount-item.labelType-' + discount.label.toString().toLowerCase() | translate }}
          - {{ discount.amount | agrCurrency: cycle.currency }}
        </div>
        <div matListItemLine class="text--gray">{{ ' ' + discount?.barn?.name }}</div>

        <div matListItemLine class="text--gray">
          {{
            'discount-item.applicabilityType-' + discount.applicabilityType.toString().toLowerCase()
              | translate
          }}
        </div>
        <div
          *ngIf="discount.linkedSlaughterReportId"
          matListItemLine
          data-test="departure-item__imported-label"
        >
          <i>{{ 'imported-slaughter-report-label' | translate }}</i>
        </div>

        <div matListItemMeta>
          <mat-slide-toggle
            [hideIcon]="true"
            style="padding-right: 30px"
            data-test="discount__toggle-active"
            color="primary"
            labelPosition="before"
            [checked]="discount.showInFinalSetup"
            (click)="$event.stopPropagation()"
            (change)="onToggleShowInFinalSetup(discount)"
            *ngIf="isFinalSetup$ | async"
          >
            <span class="text--small">{{ 'discount-showInFinalSetup' | translate }}</span>
          </mat-slide-toggle>
          @if (brandingService.isTenant('Agrifirm')) {
            <button
              *ngIf="isAdvisor"
              mat-icon-button
              (click)="delete($event, discount)"
              data-test="discount-overview__delete-item"
            >
              <mat-icon>delete</mat-icon>
            </button>
          } @else {
            <button
              *ngIf="isAdvisor"
              color="primary"
              mat-flat-button
              class="tenant-icon-only-flat-button"
              (click)="delete($event, discount)"
              data-test="discount-overview__delete-item"
            >
              <mat-icon>delete</mat-icon>
            </button>
          }
        </div>
      </a>
      <mat-divider *ngIf="cycle.discounts.length > 0"></mat-divider>
    </mat-nav-list>
  </ng-container>
</agr-page-toolbar>
